import { take, put, call, select } from 'redux-saga/effects';
import { CHANGE_LANGUAGE, CHANGE_LANGUAGE_SUCCESS } from '@openplatform/store/actionTypes/homepage';
import { getLanguage } from '@openplatform/utils/index';
import { immutableSelector } from '@/utils/index';

let browserSystemLanguage = navigator.language.toLowerCase() || 'zh';
if (browserSystemLanguage.startsWith('zh')) {
    browserSystemLanguage = 'zh';
} else {
    browserSystemLanguage = 'en';
}

function* changeLanguage(lang: string) {
    const { data } = yield getLanguage(lang);
    if (data) {
        document.title = data.title;
        const desEle = document.getElementById('description');
        const keywordEle = document.getElementById('keywords');
        if (desEle) {
            desEle.setAttribute('content', data.description);
        }
        if (keywordEle) {
            keywordEle.setAttribute('content', data.keywords);
        }
        localStorage.setItem('curLang', lang);
        yield put({
            type: CHANGE_LANGUAGE_SUCCESS,
            payload: { data, currentLanguage: lang },
        });
    }
}

export default function* changeLanguageFlow() {
    while (true) {
        const action = yield take(CHANGE_LANGUAGE);
        const { payload } = action;
        if (payload) {
            const {
                i18n: { platform, currentLanguage },
            } = yield select((state) => immutableSelector(state));
            if (payload !== currentLanguage || Object.keys(platform)?.length === 0) {
                // 语言发生变化或者 store 中 platform 对象为空时需要重新加载语言文件
                yield call(changeLanguage, action.payload);
            } else {
                // 如果语言与上次相同直接返回原语言文件，不需要重新加载
                yield put({
                    type: CHANGE_LANGUAGE_SUCCESS,
                });
            }
        } else {
            const language =
                (localStorage.getItem('curLang') as 'zh' | 'en') || browserSystemLanguage;
            yield call(changeLanguage, language);
        }
    }
}
